import { environmentBanner, type EnvironmentName } from '../lib/environment'

/**
 * The not-prod strip. OPS-46.
 *
 * Renders NOTHING on prod and nothing before the read returns; on any other
 * answer, one line in build-state amber (`--surface-pending` — "unfinished",
 * the one colour in the system that already means "this is not the real
 * thing", see tokens/colors.css). Not dismissible, deliberately: a person who
 * dismissed it on dev and then opened prod in the next tab would have no way
 * to tell them apart, which is the failure the strip exists to prevent.
 *
 * In flow above the hubbar rather than fixed, so it costs the tabbar and the
 * drawer none of their bottom-edge arithmetic (SHL-18, SHL-23) and cannot
 * cover anything.
 */
export function EnvironmentBanner({ name }: { name: EnvironmentName | null }) {
  const banner = environmentBanner(name)
  if (!banner) return null
  return (
    <div className="envbanner" role="status" data-environment={name ?? undefined}>
      <span className="envbanner__tag">{banner.tag}</span>
      <span className="envbanner__body">{banner.body}</span>
    </div>
  )
}
